"use client";
import { useEffect, useMemo, useState } from "react";
import { icons } from "./icons";

export default function DarkMode({ cl }) {
	const modes = useMemo(() => ["light", "dark"], []);
	const [mode, setMode] = useState(
		localStorage.getItem("heroMesherTheme") || modes[0]
	);

	useEffect(() => {
		localStorage.setItem("heroMesherTheme", mode);

		document.documentElement.classList.remove(
			modes[mode === modes[0] ? 1 : 0]
		);
		document.documentElement.classList.add(
			localStorage.getItem("heroMesherTheme")
		);
	}, [mode, modes]);

	return (
		<div
			className={cl}
			onClick={() => setMode(modes[mode === modes[0] ? 1 : 0])}
		>
			{icons[mode === modes[1] ? "luminosity" : "moon"]}
		</div>
	);
}
